import gql from 'graphql-tag';

export default gql`
  mutation cancelQuoteRequest($id: ID!) {
    quoteRequest: cancelQuoteRequest(id: $id) {
      id
    }
  }
`;
